import { GlobalPlayerButton } from '@tunasong/audio-ui'
import { useSelector } from '@tunasong/redux'
import { BackButton } from '@tunasong/ui-lib'
import cn from 'classnames'
import type { HTMLAttributes, JSX, Ref } from 'react'
import styles from './header.module.css'

interface HeaderProps extends HTMLAttributes<HTMLDivElement> {
  hideOnScrollTarget?: Node
  breadcrumbs?: JSX.Element
  controls?: JSX.Element | (JSX.Element | null)[]
  /** Show status icons - connectivity, MIDI, etc.  */
  showStatus?: boolean
  /** Show Back button */
  showBackButton?: boolean
  color?: string
  position?: string
  elevation?: number
  ref?: Ref<HTMLDivElement>
}

export const Header = (props: HeaderProps) => {
  const {
    showBackButton = true,
    ref,
    controls,
    breadcrumbs,
    showStatus = true,
    color: _color,
    position: _position,
    elevation: _elevation,
    className,
    ...restProps
  } = props
  const isLoggedIn = useSelector(state => state.user.isLoggedIn)

  /** Show spinner if loading songs */
  if (!isLoggedIn) {
    return null
  }

  return (
    <div className={cn(styles.appBar, className)} {...restProps} ref={ref}>
      <div className={styles.toolbar}>
        {showBackButton ? <BackButton className={styles.backButton} /> : <div className={styles.placeholder} />}
        <div className={styles.breadcrumbs}>{breadcrumbs}</div>

        <GlobalPlayerButton showStatus={showStatus} />

        {controls}
      </div>
    </div>
  )
}
